export const locale = {
  lang: 'fr',
  data: {
    guards: {
      notSupportedDevice: {
        message: `L’appareil que vous utilisez n’est pas pris en charge pour remplir le formulaire. Veuillez utiliser une tablette ou un ordinateur (portable ou de bureau).`,
        title: 'Attention'
      }
    }
  }
};
